import http from '../store/http/http-common';

export interface ExtraModule {
  key: string;
  name: string;
  description: string;
  appPath?: string;
}

// Use the enabled modules to expose a new app module's route/navigation.
// Its API controller must also use @RequiresModule(key).
export async function getEnabledModules(): Promise<ExtraModule[]> {
  return (await http.get('/application/modules')).data;
}
